import { Pipe, PipeTransform } from '@angular/core';

import { SharedService } from 'src/app/core/services/shared.service';

@Pipe({
  name: 'investor'
})
export class InvestorPipe implements PipeTransform {
  constructor(private sharedService: SharedService) {}

  transform(value: any): any {
    const investor = {
      norwegianIndividual: { en: 'Norwegian private person', no: 'Norsk privatperson' },
      norwegianCompany: { en: 'Norwegian company', no: 'Norsk selskap' },
      withoutDNumber: { en: 'foreign individual without D-number', no: 'utenlandsk privatperson uten D-nummer' },
      withDNumber: { en: 'foreign individual with D-number', no: 'utenlandsk privatperson med D-nummer' },
      individualWithUTL: { en: 'foreign private person with aksjonaer id', no: 'utenlandsk privatperson med aksjonær-id' },
      individualWithoutUTL: { en: 'foreign private person without aksjonaer id', no: 'utenlandsk privatperson uten aksjonær-id' },
      companyWithUTL: { en: 'foreign company with aksjonaer id', no: 'utenlandsk selskap med aksjonær-id' },
      companyWithoutUTL: { en: 'foreign company without aksjonaer id', no: 'utenlandsk selskap uten aksjonær-id' }
    };
    return investor[value][this.sharedService.language];
  }
}
